import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCsvExportService } from '../utils/abstract-csv-export.service';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';
import { NetzbetreiberTeilgebieteInfo } from '../auth/netzbetreiber-teilgebiete-info';


@Injectable({
    providedIn: 'root',
})
export class NetzzuordnungExportService extends AbstractCsvExportService {

    protected http: HttpClient;
    protected fileSaverService: FileSaverService;

    constructor() {
        super(inject(HttpClient), inject(FileSaverService));
    }

    public exportNetzzuordnungen(teilgebiet?: NetzbetreiberTeilgebieteInfo) {
        this.exportCsv(
            '/netzzuordnung/netzzuordnungen.csv',
            FileSaverUsecase.CSV_EXPORT_NETZZUORDNUNGEN,
            teilgebiet,
        );
    }
}



